import {
  Directive,
  OnInit,
  ElementRef,
  Input,
  OnDestroy,
} from '@angular/core';
import { WatermarkService, WatermarkConfig } from './watermark.service';

/**
 * 水印指令 - 在宿主元素上添加水印
 *
 * 用法：
 * <div appWatermark [watermarkConfig]="config"></div>
 * <div appWatermark text="机密" color="rgba(255,0,0,0.1)"></div>
 */
@Directive({
  selector: '[appWatermark]',
})
export class WatermarkDirective implements OnInit, OnDestroy {
  /** 完整配置对象 */
  @Input('appWatermark') set config(value: Partial<WatermarkConfig>) {
    if (value) {
      this._config = value;
    }
  }
  get config(): Partial<WatermarkConfig> {
    return this._config;
  }
  private _config: Partial<WatermarkConfig> = {};

  /** 水印文字 */
  @Input() set waterText(value: string) {
    this._config.text = value;
  }

  /** 水印颜色 */
  @Input() set waterColor(value: string) {
    this._config.color = value;
  }

  constructor(
    private el: ElementRef<HTMLElement>,
    private watermarkService: WatermarkService,
  ) {}

  ngOnInit(): void {
    this.watermarkService.create(this._config, this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.watermarkService.remove();
  }
}
